module.exports = global["Tether"] = require("-!c:\\OpenServer\\domains\\localhost\\prestapro\\ps17\\diamond\\themes\\diamond\\_dev\\node_modules\\babel-loader\\lib\\index.js??ref--0!.\\tether.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?Tether!./~/tether/dist/js/tether.js
// module id = 28
// module chunks = 0